import SelectInput from '@/core/components/inputs/SelectInput/SelectInput';

export default SelectInput;
